<template>
  <div class="config-meetings f-w f-h">
    <MeetingPlanningItem
      v-for="planning in plannings"
      :key="planning.id"
      :meeting-planning="planning"
      from-config
    />
    <button class="add-button add-planning mt10em mb40em" @click="addPlanning()">
      <Icon>{{ addCircleMedium }}</Icon>
      {{ $t("message.ADD_PLANNING") }}
    </button>
  </div>
</template>

<script>
/**
 * Config page to edit and create meetings templates
 */

import { createNamespacedHelpers } from 'vuex';
// Components
import Icon from '@/components/icon.vue';
import MeetingPlanningItem from '@/components/meeting-planning-item.vue';
// Mixins
import mixinConfigPages from '@/mixins/config-pages.vue';
// Utils
import { FETCH_PLANNINGS, SET_PLANNING } from '@/store/modules/meeting/action-types';
import { GET_PLANNINGS } from '@/store/modules/meeting/mutation-types';
import { SET_COMPANY_PARAM } from '@/store/modules/config/action-types';
import { REPEAT_TYPE, DEFAULT_REPEAT_DATA } from '@/utils/meeting-utils';
import { addCircleMedium } from '@/assets/icons';

const { mapState: meetingMapState } = createNamespacedHelpers('meeting');

export default {

  name: 'ConfigMeetings',

  components: {
    Icon,
    MeetingPlanningItem,
  },

  mixins: [mixinConfigPages],

  data() {
    return {
      addCircleMedium,
      allEditableParams: [
        'allowCfgTemplateFromTeam',
      ],
      // Properties used by other components. See src/views/readme.md
      pageTitle: this.$t('message.SETTINGS_MEETINGS'),
    };
  },

  computed: {
    ...meetingMapState({
      plannings: state => state[GET_PLANNINGS.stateKey] || [],
      planningsLoading: state => state[GET_PLANNINGS.loadingKey],
    }),
  },

  methods: {
    refresh() {
      if (!this.planningsLoading) {
        this.$store.dispatch(`meeting/${FETCH_PLANNINGS}`);
      }
    },
    /** Set company params */
    setParams() {
      const params = {};
      this.allEditableParams.forEach((param) => {
        params[param] = this.company[param];
      });
      this.$store.dispatch(`config/${SET_COMPANY_PARAM}`, params);
    },
    /** Create a new meeting planning */
    addPlanning() {
      const params = {
        id: 0,
        repeatType: REPEAT_TYPE.daily,
        repeatData: DEFAULT_REPEAT_DATA[0],
        participantIds: this.thisTeamIds,
      };
      this.$store.dispatch(`meeting/${SET_PLANNING}`, params);
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/vars.scss";
.config-meetings {
  padding-op: 1.5rem;
  overflow: auto;
}
</style>
